const VALIDATOR_TYPE_REQUIRE = 'REQUIRE';
const VALIDATOR_TYPE_NOT_REQUIRE = 'NOT REQUIRE';
const VALIDATOR_TYPE_MINLENGTH = 'MINLENGTH';
const VALIDATOR_TYPE_MAXLENGTH = 'MAXLENGTH';
const VALIDATOR_TYPE_MIN = 'MIN';
const VALIDATOR_TYPE_MAX = 'MAX';
const VALIDATOR_TYPE_EMAIL = 'EMAIL';
const VALIDATOR_TYPE_FILE = 'FILE';
const VALIDATOR_TYPE_EMPTY_INPUT='EMPTY INPUT';
const VALIDATOR_TYPE_NUMERIC='NUMERIC';
const VALIDATOR_TYPE_SPECIAL_CHARACHTER='SPECIAL CHARACHTER';

export const VALIDATOR_REQUIRE = () => ({ type: VALIDATOR_TYPE_REQUIRE });
export const VALIDATOR_NOT_REQUIRE = () => ({ type: VALIDATOR_TYPE_NOT_REQUIRE });
//** */
export const VALIDATOR_EMPTY_INPUT = () => ({ type: VALIDATOR_TYPE_EMPTY_INPUT });
export const VALIDATOR_FILE = () => ({ type: VALIDATOR_TYPE_FILE });
export const VALIDATOR_MINLENGTH = val => ({
  type: VALIDATOR_TYPE_MINLENGTH,
  val: val
});
export const VALIDATOR_MAXLENGTH = val => ({
  type: VALIDATOR_TYPE_MAXLENGTH,
  val: val
});
export const VALIDATOR_MIN = val => ({ type: VALIDATOR_TYPE_MIN, val: val });
export const VALIDATOR_MAX = val => ({ type: VALIDATOR_TYPE_MAX, val: val });
export const VALIDATOR_EMAIL = () => ({ type: VALIDATOR_TYPE_EMAIL });
export const VALIDATOR_NUMERIC = val => ({ type: VALIDATOR_TYPE_NUMERIC, val: val });
export const VALIDATOR_SPECIAL_CHARACHTER = () => ({ type: VALIDATOR_TYPE_SPECIAL_CHARACHTER});

export const isNumber = val => {
  if (typeof val != "string") return false
  return !isNaN(val) && !isNaN(parseFloat(val))
}

function containsSpecialChars(str) {
  const specialChars =
    '[`!@#$%^&*()_+-=[]{};\':"\\|,.<>/?~]/';
  return !(specialChars
    .split('')
    .some((specialChar) => str.includes(specialChar)));
}

export const validate = (value, validators) => {
  let isValid = true;

  for (const validator of validators) {
    if (validator.type === VALIDATOR_TYPE_REQUIRE) {
      isValid = isValid && value.trim().length > 0;
    }
    if (validator.type === VALIDATOR_TYPE_NOT_REQUIRE) {
      continue;
    }
    if (validator.type === VALIDATOR_TYPE_EMPTY_INPUT){
      isValid= isValid && true;
    }
    if (validator.type === VALIDATOR_TYPE_MINLENGTH) {
      isValid = isValid && value.trim().length >= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MAXLENGTH) {
      isValid = isValid && value.trim().length <= validator.val;
    }
    
    if (validator.type === VALIDATOR_TYPE_MIN) {
      isValid = isValid && +value >= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MAX) {
      isValid = isValid && +value <= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_EMAIL) {
      isValid = isValid && /^\S+@\S+\.\S+$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_NUMERIC) {
      isValid = isValid && value.trim().length > 0 && isNumber(value.trim());
    }
    if (validator.type === VALIDATOR_TYPE_SPECIAL_CHARACHTER) {

      isValid = isValid && containsSpecialChars(value);
    }
  }
  return isValid;
};
